// eslint-disable-next-line import/no-unresolved
import { GraphQLClient } from 'graphql-request';

import { getSdk, Sdk } from '../generated/payment-public-graphql';
import getEnv from '../utils/getEnv';

export class PaymentPublicClient {
  sdk: Sdk;

  constructor(versionNumber?: string) {
    const graphQLClient = new GraphQLClient(
      PaymentPublicClient.getPaymentURL(versionNumber)
    );
    this.sdk = getSdk(graphQLClient);
  }

  /**
   * Returns a SDK of rating-quoting backend.
   * @returns a sdk that has all APIs of rating-quoting backend.
   */
  public getSDK(): Sdk {
    return this.sdk;
  }

  /**
   * Retrieves email address by quote id or application group id.
   *
   * @param {string} quoteOrGroupId Quote id or application group id to get email address.
   * @returns {Promise<string>} Returns a Promise for a string of email address
   */
  public async getEmailAddress(quoteOrGroupId: string): Promise<string> {
    const result = await this.sdk.getEmailAddress({
      quoteOrGroupId
    });
    return result.getEmailAddress;
  }

  static versionUrl(baseUrl: string, versionNumber?: string): string {
    // regex to replace version number in url
    const regex = /\d{4}-\d{2}-\d{2}/g;
    return versionNumber ? baseUrl.replace(regex, versionNumber) : baseUrl;
  }

  public static getPaymentURL(versionNumber?: string): string {
    const { REACT_APP_PAYMENT_PUBLIC_GRAPHQL_URL } = getEnv();

    return PaymentPublicClient.versionUrl(
      REACT_APP_PAYMENT_PUBLIC_GRAPHQL_URL,
      versionNumber
    );
  }
}
